import React from "react";
import Navbar from "../components/Navbar";
import Footer from "../components/footer";
import HeroImg2 from "../components/HeroImg2";
import AboutContent from "../components/AboutContent";
import "../components/AboutStyles.css";

const About = () => {
  return (
    <div>
      <Navbar />
      <HeroImg2
        heading="ABOUT"
        text={
          <div className="abt">
            <p>
              Welcome to VIRXEE, where we transform digital aspirations into
              reality. As a leading player in the world of Social Media
              Marketing Advertising, we're not just a marketing agency; we're
              your strategic partners in navigating the ever-changing landscape
              of online success.
            </p>
            <div className="ostory">
              <h3>Our Story</h3>
              Founded in 2022, VIRXEE has evolved from a humble startup into a
              dynamic force in the digital landscape. Over the years, we've
              honed our skills and expertise to become trailblazers in the SMMA
              industry, serving businesses of all sizes with the unquenchable
              thirst for knowledge, and a genuine desire to make a difference.
            </div>
            <div className="odf">
              <h3>Our Driving Force</h3>
              <center>At VIRXEE, we're guided by a few key principles:</center>
              <br />
              <b>1. Innovation</b>: We're dedicated to staying at the forefront
              of SMMA trends, ensuring our clients benefit from cutting-edge
              strategies and tactics.
              <br />
              <b>2.Client Success</b>: Your success is our ultimate goal. We
              invest our energy and expertise into crafting strategies that
              align perfectly with your unique goals.
              <br />
              <b>3.Collaboration</b>: We value collaboration and open
              communication. Working closely with you, we build strong
              partnerships that lead to exceptional outcomes.
              <br />
              <b>4.Integrity</b>: Trust is our foundation. We uphold the highest
              ethical standards, ensuring transparency and honesty in every
              interaction.
            </div>
            <div className="ot">
              <h3>Our Team</h3>
              Our team is the heart of VIRXEE. Comprising seasoned SMMA experts
              and creative minds, we bring a wealth of knowledge and innovation
              to every project.
            </div>
            <div className="ofr">
              <h3>What We Offer</h3>
              <b>SMMA Services: </b>
              We offer a comprehensive suite of social media management services
              including content creation & development, brand strategy
              consultancy, PR/SEO optimization, paid advertising, and more.
              <br />
              <b>Tailored Solutions: </b>
              Every client is unique, and so are our strategies. We create
              bespoke plans that address your specific needs and objectives.
              <br />
              <b>Dedicated Support:</b>
              Our commitment doesn't end at project completion. We're here to
              provide ongoing support and guidance, ensuring your continued
              success.
            </div>
            <div className="joinus">
              <h3>Join Us on the Digital Journey</h3>
              We invite you to embark on a journey of digital transformation
              with VIRXEE. Let's collaborate to elevate your brand's online
              presence and achieve remarkable results in the dynamic world of
              social media marketing advertising.
              <br /> Ready to make a splash in the digital arena? Contact us
              today to explore how VIRXEE can be your partner in SMMA success.
              <br />
              Contact:
              <a
                href="mailto:vxy@virxee.onmicrosoft.com"
                style={{ fontSize: "25px", color: "gold" }}
              >
                {" "}
                vxy@virxee.onmicrosoft.com
              </a>
            </div>
          </div>
        }
        // text2="We facilitate E-commerce companies growth through the delivery of qualified leads, eliminating the need for extensive effort on your part."
        // text3="Get 10 new qualified leads within 30 days or you don't pay."
        // divs="Your Satisfaction is our minimum output result "
      />
      <AboutContent />

      {/* <div className='projDesc'>
        <center><h4>Projects Description and Links</h4></center>
        <div className='footer-container'>
          <div className='left'>
            <h4>Archived Thoughts</h4>
            <p>My PHP E-Book library designed using w3 css and
              bootstrap. Collects Books from api source</p>
            <a href='#'>Link Here</a>
          </div>
          <div className='right'>
            <h4>Men Salon Management system</h4>
            <p>My PHP based project designed to ease and manage large records 
              by it's interractive user-interface and data collection method.</p>
            <a href='#'>Link Here</a>
          </div>
        </div>
      </div> */}
      <Footer />
    </div>
  );
};

export default About;
